import type { IconSvgObject } from './types';

const Stairs01Icon: IconSvgObject = [
  ["path", { d: "M16.5 3.5H19.5C20.0523 3.5 20.5 3.94772 20.5 4.5V18.5C20.5 19.6046 19.6046 20.5 18.5 20.5H4.5C3.94772 20.5 3.5 20.0523 3.5 19.5V16.5C3.5 15.9477 3.94772 15.5 4.5 15.5H7.5V12.5C7.5 11.9477 7.94772 11.5 8.5 11.5H11.5V8.5C11.5 7.94772 11.9477 7.5 12.5 7.5H15.5V4.5C15.5 3.94772 15.9477 3.5 16.5 3.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Stairs01Icon;
